<template>
  <div class="modal" :class="{active: show == true}">
    <div v-if="show == true" class="overlay" @click="close()">
      <div class="content" :style="{'height': height}" @click.stop=""> <!-- to stop propagation of event from going to parent and triggering 'close()' -->
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    height: {
      default: 'auto',
      type: String,
    },
    onClosed: {
      type: Function
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    open: function () {
      this.show = true
    },
    close: function () {
      this.show = false
      this.onClosed && this.onClosed()
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  top: 0;
  left: 0;
  z-index: 2;
  position: fixed;
  &.active {
    width: 100%;
    height: 100%;
  }
}

.overlay {
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
}

.content {
  max-width: 600px;
  min-height: 200px;
  background: white;
  margin: 10% auto 0;
  border-radius: 3px;
}

@media screen and (max-width: 768px) {
  .content {
    margin-top: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// apps/comps/Modal.vue